import { render, staticRenderFns } from "./HeaderSidebar.vue?vue&type=template&id=0bdb726b&"
import script from "./HeaderSidebar.vue?vue&type=script&lang=js&"
export * from "./HeaderSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports